export function withFlag(flags, key, wanted) {
    return wanted
        ? [...new Set([...(flags ?? []), key])]
        : (flags ?? []).filter((flag) => flag !== key)
}

export function toDetailBody(detail) {
    return {
        type: detail.type,
        name: detail.name,
        value: detail.value,
        flags: detail.flags ?? [],
    }
}

export function toAddressBody(address) {
    return {
        type: address.type,
        city: address.city,
        street: address.street,
        number: address.number,
    }
}
